export default "__VITE_ASSET__32efd787__"